import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { StyledUiRadio } from './UiRadio.styles';

const UiRadio = ({ name, control, ...rest }) => {
  if (name && control)
    return (
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <StyledUiRadio
            name={name}
            checked={field.value}
            color='primary'
            {...field}
            {...rest}
          />
        )}
      />
    );
  return <StyledUiRadio name={name} color='primary' {...rest} />;
};

UiRadio.propTypes = {
  name: PropTypes.string,
  control: PropTypes.object,
};

export default UiRadio;
